import { ComponentCO2 } from '@acies/domain';
import CO2Model from '../models/co2-model';
import PhasesCO2Model from '../models/phases-co2-model';

export default class PhasesCO2Controller {
	#phasesCO2Model: PhasesCO2Model;
	#selectedComponentCO2: ComponentCO2 | null;
	public constructor(co2Model: CO2Model) {
		this.#phasesCO2Model = co2Model.phasesCO2Model;
		this.#selectedComponentCO2 = null;
	}

	public set selectedComponentCO2(value: ComponentCO2 | null) {
		if (this.#selectedComponentCO2 === value) {
			return;
		}
		this.#selectedComponentCO2 = value;
		this.#phasesCO2Model.updatePhasesBindings(value);
	}

	public get selectedComponentCO2(): ComponentCO2 | null {
		return this.#selectedComponentCO2;
	}
}
